<template>
  <div class="spending-space">
    <div style="height:100%">
      <div
        style="
          display: flex;
          justify-content: flex-start;
          height: 30px;
          line-height: 30px;
          padding: 0 0 0 20px;
        "
      >
        <div class="go-back" @click="goback">返回></div>
        <div style="padding-left: 20px; font-weight: bold">待删除车位</div>
      </div>
         <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float"> 
    <div class="form-group">
            <label>车位号:</label>
            <input
              v-model="search.parkingUniqueId"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
    
      <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="tableLoading"
              >
                查询
              </el-button>
            </span> 
      
          </div>
        </form>
      </div> 
      <template>
        <div v-show="showList"   style="height: calc(100% - 200px)">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-if="tableListData && tableListData.length > 0"
            v-loading="tableLoading"
          >
            <!-- <el-table-column
              show-overflow-tooltip
              label="归属停车场"
              prop="parkingName"
            ></el-table-column> -->
            <el-table-column
              show-overflow-tooltip
              label="客户名称"
              prop="parkingOwner"
            ></el-table-column>
                <el-table-column
              show-overflow-tooltip
              label="楼层"
              prop="parkingLayer"
            >
            </el-table-column>
            <el-table-column show-overflow-tooltip label="区域" prop="areaName"></el-table-column>
            <el-table-column show-overflow-tooltip label="车位号" prop="parkingUniqueId">
           
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="联系人"
              prop="parkingOwner"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="手机号码"
              prop="parkingOwnerPhone"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="200px">
              <template slot-scope="scope">
                <button
                  class="edit operate-button"
                  type="button"
                  @click="onAuditClick(scope.row)"
                >
                  审核
                </button>
              </template>
            </el-table-column>
          </el-table>
          <div
            v-else
            style="
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
      </template>

      <Page v-show="showList" v-on:pagination="receivePaginationData"></Page>
    </div>

    <el-dialog
      title="审核"
      :visible.sync="auditDialogVisible"
      width="400px"
      @close="handleAuditCancel"
    >
      <el-form :model="auditForm" label-width="0">
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            v-model="auditForm.reason"
            placeholder="请输入原因"
            :autosize="{ minRows: 3, maxRows: 5 }"
          ></el-input>
        </el-form-item>
        <el-form-item prop="result" style="text-align: center">
          <el-radio-group v-model="auditForm.result">
            <el-radio label="pass">通过</el-radio>
            <el-radio label="reject">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="handleAuditCancel">取 消</el-button>
        <el-button type="primary" @click="handleAuditConfirm(auditForm.result)"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { pendingSpaceDeleteList, auditSpaceDelete } from "@/api/url";

import Page from "@/page/commons/page";

import { AUDIT_STATUS_TYPE } from "./constant";

export default {
  data() {
    return {
      spaceTypes: { 个人: "个人", 企业: "企业" },

      shareParksData: [],
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      parkingList: [],
      switchValue: "list",
      showList: true,
      showChart: false,
      showTimeDay: true,
      showTimeMonth: false,
      auditStatusType: { ...AUDIT_STATUS_TYPE },
      echartSearch: {
        beginTime: "",
      },
      search: {
        pageSize: 10,
        pageNumber: 1,
        parkingId: undefined,
        auditStatus: undefined,
        parkingId: undefined,
        parkingType: "",
        parkingUniqueId:""
      },
      tableListData: [
        {
          id: "1",
          parkingOwner: "111",
          parkingUniqueId: "222",
          lockId: "333",
          parkingType: "444",
          auditStatus: "1",
        },
      ],
      tableListDataTitle: [],
      property_audit_btn: false,
      platform_audit_btn: false,
      dialogLockFormVisible: false,
      form: {
        gatewayIds: "",
        lockIds: "",
      },
      formLabelWidth: "120px",
      gates: [],
      locks: [],
      id: "",
      editForm: {},
      dialogSpaceFormVisible: false,
      currentSpace: {},
      batchImportDialogFormVisible: false,
      auditDialogVisible: false,
      auditForm: {
        reason: "",
        result: "",
      },
      currentAuditRow: null,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage = 1) {
      var _this = this;
      this.tableLoading = true;
      _this.tableListData = [];
      this.$get(pendingSpaceDeleteList(), {
        page: curPage,
        limit: this.search.pageSize,
        parkingId: this.search.parkingId,
        toBeDeleted: 1, // 1:待删除
        parkingUniqueId:this.search.parkingUniqueId
      })
        .then((data) => {
          if (data?.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
          console.log("tableListData=>", _this.tableListData);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    goback() {
      this.$router.go(-1);
    },
    onAuditClick(row) {
      this.currentAuditRow = row;
      this.auditForm.reason = "";
      this.auditForm.result = "";
      this.auditDialogVisible = true;
    },
    async handleAuditConfirm(result) {
      if (!this.auditForm.reason) {
        this.$message.warning("请输入原因");
        return;
      }
      if (!this.auditForm.result) {
        this.$message.warning("请选择审核结果");
        return;
      }
      // TODO: 可在此处调用接口提交审核结果
      // result: 'pass' 或 'reject'
      // this.currentAuditRow 可用于传递当前审核行
      const res = await this.$putRequest(auditSpaceDelete(), {
        id: this.currentAuditRow.id,
        isDelete: this.auditForm.result == "pass" ? 1 : 2,// 1:删除，2：不删除
        parkingId: this.search.parkingId,
        userId: this.currentAuditRow.userId,
      });
      if (res.status !== 200) {
        this.$message.error(res.message);
        return;
      }
      this.$message.success("审核成功");
      this.auditDialogVisible = false;
      this.tableList(this.curIndex);
    },
    handleAuditCancel() {
      this.auditDialogVisible = false;
    },
     searchList() {
      this.search.pageNumber = 1;
      this.tableList(1);
    },
  },

  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.property_audit_btn = this.elements["property_audit"];
      this.platform_audit_btn = this.elements["platform_audit"];
    },
  },
  components: {
    Page,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.search.parkingId = this.$route.query.parkingId;
    if (this.search.parkingId) {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    }
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.spending-space {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
</style>
<style>
.bosk-table .el-select {
  width: 100px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
.bind-lock-dialog .el-select {
  width: 70%;
}
.el-button {
  font-weight: lighter;
}
.go-back {
  font-size: 16px;

  cursor: pointer;
  color: #409eff;
}
</style>
